export default "/assets/website/images/minus.svg?4192de810fd1eceedc070b56e2ae54b2";